import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/societe', label: 'La Société' },
    { path: '/financement', label: 'Financement' },
    { path: '/assurance', label: 'Assurance' },
    { path: '/partenaires', label: 'Partenaires' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 lg:px-24">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img 
              src="https://public.readdy.ai/ai/img_res/bc022dfb-3a82-49e7-a9be-4ade168730ce.png" 
              alt="SOCIÉTÉ VAUCLUSIENNE D'AUTOMOBILES"
              className="h-12 w-auto object-contain"
            />
          </Link>

          {/* Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? isScrolled || !isHome
                      ? 'text-[#1a2b4a]'
                      : 'text-white'
                    : isScrolled || !isHome
                    ? 'text-[#4a4a4a] hover:text-[#1a2b4a]'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className={`lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
              isScrolled || !isHome ? 'text-[#1a2b4a]' : 'text-white'
            }`}
          >
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </header>
  );
}
